import img1 from "./images/1.png";
import img2 from "./images/2.png";
import bulb from "./images/bulb1.png";
import img3 from "./images/3.png";
import img4 from "./images/4.png";
import img5 from "./images/5.png";
import img6 from "./images/6.png";
import img7 from "./images/7.png";
import img8 from "./images/8.png";
import img9 from "./images/9.png";
import car from "./images/services/car.png";
import charge from "./images/services/charge.png";
import cyber from "./images/services/cyber.png";
import cyl from "./images/services/cyl.png";
import elect from "./images/services/elect.png";
import heat from "./images/services/heat.png";
import led from "./images/services/led.png";
import robo from "./images/services/robo.png";

export const content = [
  {
    id: 7,
    heading: "AUTOSAR MIGRATION AND INTEGRATION",
    para: "CellusTech India hold expertise in AUTOSAR Migration and Integration services. ",
    bulb: car,
  },
  {
    id: 8,
    heading: "CYBER SECURITY SOLUTIONS",
    para: "We offers Overall Cybersecurity Management with a team having extensive knowledge of ISO 26262 Functional Safety and ISO 21434 Cybersecurity.",
    bulb: cyber,
  },

  {
    id: 1,
    heading: "Complete Lighting Solution(LED and smart LED)",
    para: "We do manufacture, Dealing and Servicing the complete lighting solution including incandance , CFL and LED Lights with the variety of the designs.",
    bulb: led,
  },
  // {
  //   id: 2,
  //   heading: "SOLAR PANEL COMPLETE SOLUTION OF SOLAR ENERGY",
  //   para: "We do manufacture, Dealing and Servicing LED Light by considering the energy efficient envirnment (The Green Envirnment).",
  //   bulb: robo,
  // },
  // {
  //     heading:'ICE CUBE MACKING MACHINE/ DEFREEZERS/ COOLING COUNTER',
  //     para:'We do Manufacture, Dealing and Servicing of Ice Cube making Machines, Defreezers with the varieties',
  //     bulb:img2
  // },

  // {
  //   id: 5,
  //   heading: "POWER DISTRIBUTION PANEL",
  //   para: "We do Manufacure, Dealing and Servicing of Water Purifying Filters, Reverse Osmosis and the complete purifying Solution of Water.",
  //   bulb: charge,
  // },
  {
    id: 6,
    heading: "ELECTRICAL AND ELECTRONIC SERVICES",
    para: " We do provide the services to Electrical and Electronics Parts of all Kind.We do provide the services to Electrical and Electronics Parts of all Kind.",
    bulb: elect,
  },

  // {
  //   id: 3,
  //   heading:
  //     "ICE CUBE MAKING MACHINES",
  //   para: "We do Manufacture, Dealing and Servicing of All Kind of Refrigeration Equipments.",
  //   bulb: heat,
  // },
  // {
  //     heading:'SERVICING/ SALE & PURCHASE OF USED REFRIGERATION MACHINERY',
  //     para:'We do Manufacture, Dealing and Servicing of Ice Cube making Machines, Defreezers with the varieties.',
  //     bulb:img4
  // },
  // {
  //   id: 4,
  //   heading: "REVERSE OSMOSIS ",
  //   para: "We do Manufacture , Dealing and Servicing of Air conditioners, Water Coolers and Refrigerators with the varieties, Dealing and Servicing of Air conditioners",
  //   bulb: cyl,
  // },
];
